import React, { forwardRef } from "react";
import { ButtonBase } from "@mui/material";

export default function WithTouchRipple(OriginalComponent: any) {
  return (props: any) => {
    const Wrapper = !props.component
      ? ButtonBase
      : forwardRef((ButtonBaseProps, ref) => (
          <ButtonBase
            component={props.component}
            {...ButtonBaseProps}
            ref={ref}
          />
        ));
    return <OriginalComponent {...props} component={Wrapper} />;
  };
}
